w<template>
  <UiModal class="is-small" close-on-overlay @close="close">
    <template slot="header">
      <div class="modal-card-title">Отображаемые столбцы</div>
    </template>

    <template slot="content">
      <div v-for="(col, i) in columns" :key="i" class="checkbox-wrapper">
        <UiCheckbox
          :id="`checkbox-${i}`"
          v-model="col.visible"
          class="label-left"
          :label="col.title"
        />
      </div>
    </template>

    <template slot="footer">
      <UiButton class="button is-blue is-outlined" @click="updateAndClose"> Сохранить </UiButton>
    </template>
  </UiModal>
</template>

<script>
import UiModal from '@/components/UiModal.vue'
import UiButton from '@/components/UiButton.vue'
import UiCheckbox from '@/components/UiCheckbox.vue'

import ColumnsSettingsMethods from './ColumnsSettingsMethods'

export default {
  components: { UiModal, UiButton, UiCheckbox },
  mixins: [ColumnsSettingsMethods],
  props: {
    sourceColumns: {
      type: Array,
      default: () => [],
    },
    storageId: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      columns: [],
    }
  },
  mounted() {
    this.columns = this.allowChangeVisible(this.setColVisible())
  },
  methods: {
    /**
     * Update columns visible state in table.
     * Build new column hashes and set it to LocalStorage.
     * After all close modal window.
     */
    updateAndClose() {
      this.updateColumns(this.getVisbleColumns(this.columns))

      this.colHashes().buildAndSet()

      this.close()
    },

    /**
     * Emitted `updated-columns` event with only visible columns.
     *
     * @param columns {Array} only visible columns.
     */
    updateColumns(columns) {
      this.$emit('update-columns', columns)
    },

    close() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
  @include createFlex(flexbox, nowrap, row, space-between, center, center);

  padding: rem(15px) 0;
  border-bottom: 1px solid $color-gray-50;

  .checkbox {
    width: 100%;
  }
}
</style>
